/*
import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify, {
  options: {
    customProperties: true,
  }
});

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#029ec0',
        secondary: '#ff9800',
      },
    },
  },
});
*/

// Vuetify 3 に必要な基本スタイルをインポート
import 'vuetify/styles'
import { createVuetify } from 'vuetify'

// Vuetify の設定を作成してエクスポート（main.ts で app.use されます）
export default createVuetify({
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        // Vuetify 3 ではカラー設定を 'colors' オブジェクトの中に記述します
        colors: {
          primary: '#029ec0',
          secondary: '#ff9800',
        },
      },
    },
  },
})